import { render } from "./ItemOrder.vue?vue&type=template&id=79b78b0a&scoped=true"
import script from "./ItemOrder.vue?vue&type=script&lang=js"
export * from "./ItemOrder.vue?vue&type=script&lang=js"

import "./ItemOrder.vue?vue&type=style&index=0&id=79b78b0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b78b0a"]])

export default __exports__